<ng-template #defaultTpl>
  <div class="note-view d-flex align-items-center {{ classNoteView }} {{ color }}">
    <ng-template [ngTemplateOutlet]="iconTpl"></ng-template>
    <span class="text-{{ handleTextColor(color) }}">{{ text }}</span>
  </div>
</ng-template>

<!--  custom: extra content -->
<ng-container *ngIf="extraContent; else defaultTpl">
  <ng-container *ngIf="text; else noTextTpl">
    <div class="note-view {{ color }} row mx-0 align-items-center">
      <div class="col-12 col-lg p-0">
        <div class="d-flex mb-6 mb-lg-0">
          <ng-template [ngTemplateOutlet]="iconTpl"></ng-template>
          <span class="text-{{ handleTextColor(color) }}">{{ text }}</span>
        </div>
      </div>
      <div class="col-auto p-0 align-self-center">
        <ng-template [ngTemplateOutlet]="extraContentTpl"></ng-template>
      </div>
    </div>
  </ng-container>

  <ng-template #noTextTpl>
    <div class="note-view d-flex align-items-center {{ classNoteView }} {{ color }}">
      <ng-template [ngTemplateOutlet]="iconTpl"></ng-template>
      <div class="col">
        <ng-template [ngTemplateOutlet]="extraContentTpl"></ng-template>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #iconTpl>
  <span class="svg-icon icon-note-view me-6" inlineSVG="{{ icon }}"></span>
</ng-template>

<ng-template #extraContentTpl>
  <ng-content></ng-content>
</ng-template>
